import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MegapayLoaderComponent } from 'src/app/shared/component/megapay-loader/megapay-loader.component';
import * as vo from 'src/app/core/model/server/vo/_index';
import { RebateService } from '../rebate.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedDirectivesModule } from 'src/app/shared/modules/shared-directives.module';

@Component({
  selector: 'app-edit-rebate',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    NgxSpinnerModule,
    MegapayLoaderComponent,
    MatTooltipModule,
    SharedDirectivesModule
  ],
  templateUrl: './edit-rebate.component.html',
  styleUrl: './edit-rebate.component.scss',
})
export class EditRebateComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  isLoading       = false;
  rebatePercentage: number | null = null;

  constructor(
    public  dialogRef:     MatDialogRef<EditRebateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { item: any; tierId: number; tierLabel: string },
    private rebateService: RebateService,
    private toastr:        ToastrService,
    private spinner:       NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.rebatePercentage = this.data.item.rebatePercentage;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  submit(): void {
    if (this.rebatePercentage === null || this.isPercentageInvalid) {
      this.toastr.error('Please enter a valid Rebate Percentage (0-100).');
      return;
    }

    const request: vo.UpdateBuyloadRebateRequest = {
      providerType:     this.data.item.providerType,
      rebatePercentage: this.rebatePercentage,
      isEnabled:        this.data.item.isEnabled, // preserve existing status
    };

    this.isLoading = true;
    this.spinner.show().catch(console.error);

    this.rebateService.updateRebate(request, this.data.tierId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response.status === 200) {
            this.toastr.success('Saved Changes.');
            this.dialogRef.close(true);
          } else {
            this.toastr.error('Failed to update buyload rebate. Please try again.');
          }
        },
        error: (err) => {
          this.toastr.error(err.error?.message || 'An error occurred while updating the rebate.', 'Failed to update rebate ');
        },
        complete: () => {
          this.isLoading = false;
          this.spinner.hide().catch(console.error);
        },
      });
  }

  get isPercentageInvalid(): boolean {
    return this.rebatePercentage !== null && (this.rebatePercentage < 0 || this.rebatePercentage > 100);
  }
  
}
